// Global Logging Control Initialization
// This file is a redundant backup for the logic in index.html to ensure 
// that even if index.html is bypassed, logs are suppressed.

const isProduction = process.env.NODE_ENV === 'production';
const enableLogsFlag = (typeof window !== 'undefined' && window.__ENV?.REACT_APP_ENABLE_LOGS) 
  || process.env.REACT_APP_ENABLE_LOGS;

// Default to disabled in production, enabled in development unless explicitly turned off
const shouldLogsBeEnabled = String(enableLogsFlag) === 'true';
const shouldSilence = (isProduction && !shouldLogsBeEnabled) || String(enableLogsFlag) === 'false';

const noop = () => {};

if (shouldSilence) {
  // Safe override function helper
  const safeOverride = (prop) => {
    try {
      // First try simple assignment
      console[prop] = noop;
    } catch (e) {
      // If that fails (read-only), try defineProperty
      try {
        Object.defineProperty(console, prop, {
          value: noop,
          writable: true,
          configurable: true
        });
      } catch (e2) {
        // Absolute fallback - nothing we can do
      }
    }
  };

  safeOverride('log');
  safeOverride('info');
  safeOverride('debug');
  safeOverride('warn');
  
  console.log("🚫 Console logging has been disabled by REACT_APP_ENABLE_LOGS flag.");
}

// Special case: Squelch react-pdf "AbortException" which is very noisy even in development
// It happens whenever you switch pages or tabs while a page is still rendering
const originalWarn = console.warn;
if (originalWarn !== noop) { // Only wrap if not already noop
    console.warn = (...args) => {
      if (args[0] && typeof args[0] === 'string' && 
         (args[0].includes('AbortException') || args[0].includes('TextLayer task cancelled'))) {
        return;
      }
      if (originalWarn && typeof originalWarn === 'function') {
        originalWarn.apply(console, args);
      }
    };
}

// Squelch noisy Chrome Extension "message channel closed" error
// This is a known issue with extensions like Grammarly/Loom and cannot be fixed by app code
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason?.message?.includes('A listener indicated an asynchronous response') ||
        event.reason?.message?.includes('message channel closed')) {
      event.preventDefault();
    }
  });
}
